// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"e_4g","content":"e_5g","container":"e_6g"};